import { defineMessage } from 'react-intl';

export const bookingCommonI18n = {
  cancelled: defineMessage({
    id: 'common:booking.cancelled',
    defaultMessage: 'Cancelled'
  }),
  cancellationRequested: defineMessage({
    id: 'common:booking.cancellation-requested',
    defaultMessage: 'Cancellation requested'
  }),
  confirmed: defineMessage({
    id: 'common:booking.confirmed',
    defaultMessage: 'Confirmed'
  })
};
